/**
 * @author TomaszCzura ({}
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import InputAdornment from '@material-ui/core/InputAdornment';
import {IconButton} from '@mui/material';
import {Visibility, VisibilityOff} from '@mui/icons-material';
import {Input} from '@material-ui/core';
import i18next from 'i18next';

class PasswordInput extends Component {
  constructor(props) {
    super(props);

    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);

    this.state = {
      showPassword: false,
    };
  }

  onChange(e) {
    if (this.props.validate(e.target.value)) {
      this.props.onChange(e);
    }
  }

  handleBlur(e) {
    this.props.validate(e.target.value);
  }

  handleClickShowPassword() {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  handleMouseDownPassword(event) {
    event.preventDefault();
  };

  render() {
    return (
      <div className="form-group">
        <label className="control-label visible-ie8 visible-ie9">{i18next.t('login.password')}</label>
        <div className={`input-icon ${this.props.error ? 'has-error' : ''}`}>
          <i className="fa fa-lock"/>
          <Input
            className="form-control placeholder-no-fix"
            type={this.state.showPassword ? 'text' : 'password'}
            onChange={this.onChange}
            onBlur={this.handleBlur}
            placeholder={i18next.t('login.password')}
            name="password"
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={this.handleClickShowPassword}
                  onMouseDown={this.handleMouseDownPassword}
                >
                  {this.state.showPassword ? (
                    <Visibility />
                  ) : (
                    <VisibilityOff />
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
          {this.props.error ? (<span className="help-block">{this.props.error}</span>) : null}
          {this.props.success ? (<span className="help-block">{this.props.success}</span>) : null}
        </div>
      </div>
    );
  }
}

PasswordInput.propTypes = {
  success: PropTypes.string,
  error: PropTypes.string,
  onChange: PropTypes.func,
  validate: PropTypes.func,
};

PasswordInput.defaultProps = {};

export default PasswordInput;
